var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"id":"backToTop"}},[_c('img',{attrs:{"src":require("@/assets/01/tag_backtotop.svg"),"d-none":""},on:{"click":function($event){return _vm.btt()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }